// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_gS","advertCardFooter__row":"c-a_gT","advertCardFooter__name":"c-a_gU","advertCardFooter__price":"c-a_gV","advertCardFooter__age":"c-a_gW"};